import { Component } from '@angular/core';

@Component({
  selector: 'app-approval-status-info',
  standalone: false,

  templateUrl: './data-source-approval-status-info.component.html',
  styleUrl: './data-source-approval-status-info.component.scss',
})
export class DataSourceApprovalStatusInfoComponent {}
